const LabModel = {
  created: "date",
  updated: "date",
  description: "string",
  locked: "boolean",
}

export default LabModel
